var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"15","viewBox":"0 0 13 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 0.25H8.94456L12.5 4.26089V14.75H0V0.25ZM1.5 1.75V13.25H11V4.83002L8.26973 1.75H1.5Z","fill":"#212529"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }